import { fetchApi, FetchResponse } from "../dataAccess";
import { PagedCollection } from "types/collection";
import { Survey } from "types/survey/Survey";
import { IdOutput } from "types/IdOutput";

export class SaveOutput extends IdOutput {
  public link?: string;
}

const getSurveysPath = (page?: string | string[] | undefined) =>
  `/api/surveys${typeof page === "string" ? `?page=${page}` : ""}`;

export const getSurveys = (page?: string | string[] | undefined, session?: any) =>
  async () => await fetchApi<PagedCollection<Survey>>(getSurveysPath(page), { cache: "no-cache" }, session);

export const getItemPath = (id?: string | string[] | undefined) => `/api/surveys/${id}`;

export const getItem = (id: string, session: any) =>
  async () => await fetchApi<FetchResponse<Survey> | undefined>(getItemPath(id), { cache: "no-cache" }, session);

const save = async (values: Survey, session: any = null) =>
  await fetchApi<SaveOutput>(!values["@id"] ? "/api/surveys" : values["@id"], {
    method: !values["@id"] ? "POST" : "PATCH",
    body: JSON.stringify(values),
  }, session);

export default { getItem, getItemPath, getSurveysPath, getSurveys, save };
